<template>
  <v-card elevation="0">
    <p class="text-h5 mb-7" style="display: flex; align-items: center">
      {{ languageData.projectReportEntries.head }}
       <span v-on:click.stop @click="openGuidesModal('workReporting')" class="guides-question-mark" style="padding-left: 1px">?</span>
    </p>
    <ProjectReportEntriesTable></ProjectReportEntriesTable>
    <ModalInfo @clicked="hideModalAddOrEditTimeReport" :hidden-agree-btn="true" :layout="'modalProjectReportEntriesForm'" :show-modal="isShowProjectReportEntriesModal">
      <template v-slot:body>
        <ProjectReportEntriesForm :projectReportEntriesEditData="projectReportEntriesEditData" :layout="projectReportEntriesLayout"></ProjectReportEntriesForm>
      </template>
    </ModalInfo>
  </v-card>
</template>

<script type="text/javascript">
import eventBus from "../../../event-bus/eventBus";
import ProjectReportEntriesForm from "./ProjectReportEntriesForm";
import ProjectReportEntriesTable from "./ProjectReportEntriesTable";
import ModalInfo from "../../../components/ModalInfo/ModalInfo";
import {mapActions} from "vuex";

export default {
  name: "ProjectReportEntries",
  props: {
    layout: String
  },
  components: {
    ModalInfo,
    ProjectReportEntriesTable,
    ProjectReportEntriesForm
  },
  methods: {
    ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),

    isAddProjectReportEntries: function() {
      this.isShowProjectReportEntriesModal = true;
    },
    hideModalAddOrEditTimeReport: function () {
      this.isShowProjectReportEntriesModal = false;
    },
    hideModalDeleteTimeReport: function () {
      this.isShowProjectReportEntriesModalDelete = false;
    },
    getSnackbarSuccess: function(title, message) {
      this.snackbar = {
        color: "success",
        icon: "check_circle",
        mode: "multi-line",
        position: "top",
        timeout: 7500,
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
    openGuidesModal(guideKey) {
        this.updateGuidesModalVisible({
          isGuidesModalVisible: true,
          guideKey
        });
    },
  },
  data() {
    return {
      isShowProjectReportEntriesModal: false,
      isShowProjectReportEntriesModalDelete: false,
      projectReportEntriesLayout: "add",
      projectReportEntriesEditData: {}
    }
  },
  mounted() {
    eventBus.$on("showSnackbarSuccessEntry", (dataReceive) => {
      this.getSnackbarSuccess(dataReceive.title, dataReceive.message);
    });
    eventBus.$on("saveOrUpdateProjectEntrySuccess", (dataReceive) => {
      this.isShowProjectReportEntriesModal = false;
      eventBus.$emit("showSnackbarSuccessEntry", dataReceive);
    });
    eventBus.$on("showAddProjectEntryModal", () => {
      this.isShowProjectReportEntriesModal = true;
      this.projectReportEntriesLayout = "add";
    });
    eventBus.$on("showEditProjectReportEntriesModal", (item) => {
      this.projectReportEntriesLayout = "edit";
      this.projectReportEntriesEditData = item;
      this.isShowProjectReportEntriesModal = true;
    });
    eventBus.$on('saveProjectReportEntrySuccess', () => {
      this.isShowProjectReportEntriesModal = false;
    })
  }
}
</script>